import { render, staticRenderFns } from "./TermometriaProdutos.vue?vue&type=template&id=b45a5fec&"
import script from "./TermometriaProdutos.vue?vue&type=script&lang=js&"
export * from "./TermometriaProdutos.vue?vue&type=script&lang=js&"
import style0 from "./TermometriaProdutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports